import React from 'react';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Head from 'next/head';
import Hero from '../../components/Service/CoursesTravel/Hero';
import Overview from '../../components/Service/CoursesTravel/Overview';
import Outcome from '../../components/Service/CoursesTravel/Outcome';
import About from '../../components/organisms/CoursesAbout';
import Testimonials from '../../components/organisms/Testimonials';
import StartNow from '../../components/organisms/StartNow';

const Travel = () => {
  const { t } = useTranslation('common');
  return (
    <div>
      <Head>
        <title>{t('title.courses.travelEnglish')}</title>
        <meta
          name="description"
          content={t('description.courses.travelEnglish')}
        />
      </Head>
      <div className="breadCrumb" />
      <Hero />
      <Overview />
      <Outcome />
      <About />
      <Testimonials />
      <StartNow />
    </div>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common'])),
  },
});

export default Travel;
